// import { Button, Row } from "react-bootstrap";

import { Button, Row } from "react-bootstrap";

import AttachmentUploader from "../../Attachment/AttachmentUploader";
import AttachmentViewer from "../../Attachment/AttachmentViewer";
import React from "react";
import { injectIntl } from "react-intl";

const PaymentFormAttachment = ({
  file,
  //   updateFormValue,
  createAttachment,
  deleteAttachment,
  companyId,
  intl,
  sendNotification
}) => {
  console.log("PaymentFormAttachment", file, companyId);
  if (!file) {
    console.log("ATTACHEMENT UPLOADER");
    return (
      <AttachmentUploader
        // companyId={companyId}
        // updateFormValue={updateFormValue}
        onCreateAttachment={createAttachment}
        path={`documents/${companyId}/payment/`}
        sendNotification={sendNotification}
      />
    );
  }
  //   return <div />;
  console.log("ATTACHEMENT Viewer");
  return (
    <div>
      <Row>
        {" "}
        <Button
          title={intl.formatMessage({ id: "ids_delete" })}
          onClick={deleteAttachment}
          bsStyle="primary">
          <i className="fa fa-lg fa-trash" />
        </Button>
      </Row>
      <AttachmentViewer value={file} />;
    </div>
  );
};

export default injectIntl(PaymentFormAttachment);
